<template>
	<ContactsMyInfo v-show="this.showTab === 1"></ContactsMyInfo>
	<ContactsFriendsInfo v-show="this.showTab === 2"></ContactsFriendsInfo>
</template>

<script>
import ContactsMyInfo from '@/components/User/Pay/ContactsMyInfo';
import ContactsFriendsInfo from '@/components/User/Pay/ContactsFriendsInfo';
export default {
	name: 'ContactsUserTab',
	components: {
		ContactsMyInfo,
		ContactsFriendsInfo,
	},
	data() {
		return {
			showTab: 1,
		};
	},
};
</script>

<style scoped></style>
